/* The Sunrise scene (backdrop "Sunrise", rfhq_templates.css): a button to play the sunrise again, and a button that plays a sound file with it (the file's address is on the
   button). Browsers keep sound off until the person acts, so it plays when the button is pressed; where sound is not allowed the button says so.
   The words on the buttons (playing, played, not allowed) and the sound file all come from the Hero Card in the scene; nothing is worded here. */
(function () {
	function mount(scene) {
		const replayBtn = scene.querySelector("[data-sunrise-replay]"), soundBtn = scene.querySelector("[data-sunrise-sound]");
		const text = soundBtn && soundBtn.querySelector("[data-sunrise-sound-text]");
		let audio = null;
		const replay = () => { scene.classList.add("is-replaying"); void scene.offsetWidth; window.requestAnimationFrame(() => scene.classList.remove("is-replaying")); };
		if (replayBtn) replayBtn.addEventListener("click", replay);
		if (!soundBtn) return;
		const done = (word) => { soundBtn.classList.remove("is-playing"); text.textContent = word; };
		soundBtn.addEventListener("click", () => {
			try {
				if (audio) audio.pause();
				audio = new Audio(soundBtn.dataset.src);
				audio.addEventListener("ended", () => done(soundBtn.dataset.again));
				audio.addEventListener("error", () => done(soundBtn.dataset.blocked));
				const started = audio.play();
				replay();
				soundBtn.classList.add("is-playing");
				text.textContent = soundBtn.dataset.playing;
				if (started && started.catch) started.catch(() => done(soundBtn.dataset.blocked));
			} catch (e) {
				done(soundBtn.dataset.blocked);
			}
		});
	}

	function init() { document.querySelectorAll(".rfhq-has-sunrise").forEach(mount); }
	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
